import React from 'react';
import PageHeader from "../../components/elements/PageHeader";
import {translate} from "react-i18next";
import AddCompany from "./AddCompany";
import BootstrapTable from 'react-bootstrap-table-next';
import {connect} from "react-redux";

class Companies extends React.Component {

    state = {
        loading: false
    };

    render() {
        const {t, company} = this.props;
        return (
            <div className="Companies">
                <PageHeader title={t('companies.title')} loading={this.state.loading}/>
                <div className="row m-t">
                    <div className="col-xs-12 text-right">
                        <AddCompany/>
                    </div>
                </div>
                <div className="row m-t">
                    <div className="col-xs-12">
                        <div className="white-bg">
                            <BootstrapTable keyField='id' data={company.companies} columns={
                                [
                                    {
                                        dataField: 'name',
                                        text: t('companies.table.header.name'),
                                        sort: true
                                    },
                                    {
                                        dataField: 'shortName',
                                        text: t('companies.table.header.shortName'),
                                        sort: true
                                    },
                                    {
                                        dataField: 'projects',
                                        text: t('companies.table.header.projects'),
                                        formatter: (cell) => cell ? cell.map((projectId, pI) => (
                                            <span className="label label-primary m-r-xs" key={pI}>
                                                {this.props.project.availableProjects.find(el => el.id === projectId).displayName}
                                            </span>
                                            )) : null
                                    }
                                ]
                            } defaultSorted={[{dataField: 'name', order: 'asc'}]}
                                            rowEvents={{
                                                onClick: (e, row, rowIndex) => {
                                                    if (row.id) this.props.history.push("/company/" + row.id);
                                                }
                                            }}
                                            hover
                                            bordered
                                            wrapperClasses="clickable"
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        company: state.company,
        project: state.project
    }
};

export default connect(mapStateToProps, null)(translate()(Companies));
